<div class="lum-c-timeline-list-dialog--wrapper relative px-5">
  <div class="d-flex justify-content-between">
    <div class="align-self-center">
      <h3 class="mt-4 inline">
        {{ title }}
      </h3>
    </div>
    <div class="align-self-center">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="dialogRef.close()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <mat-divider class="my-5"></mat-divider>
  <ul class="timeline">
    <ng-container *ngFor="let item of viewModel; trackBy: trackByValue">
      <li class="event" [attr.data-date]="item.date | date: 'medium'">
        <h4>{{ item.title }}</h4>
        <p *ngIf="item.subtitle">{{ item.subtitle }}</p>
      </li>
    </ng-container>
  </ul>
</div>
